export function loadingTextsFor(type: string) {
  return {
    success: `No ${type}.`,
    pending: 'Loading...',
    error: `An error occurred when loading ${type}.`,
  };
}
